const CARRIER_GUIDE_FAQ_BLACKLIST = ['cheapTripDescription', 'topRouteDescription'];

const FEATURE_MAP = {
    wifiCount: {
        label: 'bestWifiLabel',
    },
    staffCount: {
        label: 'bestStaffLabel',
    },
    valueCount: {
        label: 'bestValueLabel',
    },
    ontimeCount: {
        label: 'bestOnTimeLabel',
    },
    comfortCount: {
        label: 'bestSeatsLabel',
    },
    vehicleCount: {
        label: 'bestVehicleLabel',
    },
};

export {
    CARRIER_GUIDE_FAQ_BLACKLIST,
    FEATURE_MAP,
};
